import close from '../../assets/icons/close.svg';
import { createPortal } from 'react-dom';
import { useEffect, useRef, useState } from 'react';
import { useFocusTrap } from '../../Utils/TabIndexingFocus';

const ConfirmationModal = ({
  isOpen,
  title,
  message,
  onConfirm,
  onCancel,
  setWidth,
  showCheckbox = false,
  extraActions,
  checkboxLabel = 'Check this option',
  isSubmitting = false,
  triggerOnEnter = false,
  forceConfirm = false, // hides Cancel and close — user must confirm
}) => {

  const [isChecked, setIsChecked] = useState(false);
  const trapRef = useFocusTrap(isOpen);


  // ⭐ Trigger confirm when pressing Enter ONLY for this case
  useEffect(() => {
    if (!isOpen || !triggerOnEnter) return;

    const handleKeyPress = (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
        onConfirm(isChecked);
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => document.removeEventListener("keydown", handleKeyPress);
  }, [isOpen, triggerOnEnter, isChecked, onConfirm]);


  if (!isOpen) return null;

  return createPortal(
    <div
      className="modal-overlay"
      style={{
        zIndex: 9999999,
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div
        className="modal-content"
        style={{
          position: 'relative',
          width: setWidth || '40%',
          backgroundColor: 'white',
          zIndex: 10000000
        }}
        ref={trapRef}
      >
        <div className="modal-header-content d-flex justify-content-between align-items-center mb-3">
          <h4 className="text-primary">{title || 'Confirm Action'}</h4>
          {!forceConfirm && (
            <button className="close-btn" onClick={onCancel}>
              <img src={close} alt="close" />
            </button>
          )}
        </div>
        <div className="modal-body" style={{ overflowY: 'unset' }}>
          <p className="mt-3">{message}</p>

          {showCheckbox && (
            <div className="form-check mt-3">
              <input
                type="checkbox"
                id="confirm-checkbox"
                className="form-check-input"
                checked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <label htmlFor="confirm-checkbox" className="form-check-label">
                {checkboxLabel}
              </label>
            </div>
          )}

          {extraActions && (
            <div className="d-flex justify-content-center gap-2 mt-3">
              {extraActions}
            </div>
          )}


          <div className="d-flex justify-content-end gap-2 mt-4">
            {!forceConfirm && (
              <button
                className="btn btn-secondary"
                onClick={onCancel}
                style={{ padding: showCheckbox ? '3px 17px' : undefined }}
              >
                {showCheckbox ? 'NO' : 'Cancel'}
              </button>
            )}
            <button
              className="add-btn"
              onClick={() => onConfirm(isChecked)}
              style={{ padding: showCheckbox ? '3px 17px' : undefined }}
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <span className="spinner-border spinner-border-sm" role="status" />
              ) : (
                showCheckbox ? 'YES' : 'Confirm'
              )}
            </button>
          </div>

        </div>
      </div>
    </div>,
    document.body
  );
};

export default ConfirmationModal;